module.exports = __webpack_public_path__ + "louise.png?4a8284fa696de96967ec0ee9253f856f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/louise.png
// module id = 187
// module chunks = 0